import { IsNumber, IsOptional } from "class-validator";
import { BaseDto } from './base.dto';
import { BrandDto } from './brand.dto';
import { MerchantDto } from './merchant.dto';
import { ModifierDto } from './modifier.dto';
import { OrderServiceTypeDto } from './orderServiceType.dto';
import { ProductDto } from './product.dto';
import { ProductCategoryDto } from './productCategory.dto';
import { RecipeBookDto } from './recipeBook.dto';
import { RecipeDetailDto } from './recipeDetail.dto';
import { RecipeStockLocationDto } from './recipeStockLocation.dto';
import { RecipeTypeDto } from './recipeType.dto';


export class RecipeDto extends BaseDto {
  merchantId?:number;
  name: string;
  code: string;
  description: string;
  recipeType: RecipeTypeDto;
  recipeBook?: RecipeBookDto;
  productCategory: ProductCategoryDto;
  servingUnitTypeId: number;
  portions: number;
  portionSize: number;
  portionCost: number;
  recipeSize: number;
  recipeCost: number;
  products?: ProductDto[];
  modifiers?: ModifierDto[];
  merchant?: MerchantDto;
  brand?: BrandDto;
  recipeDetail?: RecipeDetailDto[];
  active?: boolean;
  startDate: string;
  endDate: string;
  recipeStockLocations: RecipeStockLocationDto[];
  stockCategoryLevel1Id?: number;
  stockCategoryLevel2Id?: number;
  isRecipe?: boolean;
  orderServiceType?: OrderServiceTypeDto;
  sharedSourceName?: string;
  oldRecipeId?: number;
  recipeVersion?: number;
  recipeImageUrl?: string;

  @IsOptional()
  @IsNumber()
  netRecipeSize?: number;

  recipeTypeId?: number;
  brandId?: number;
  productCategoryId?: number;
  recipeBookId?: number;
}
